// Copyright (c) Docugami, Inc. All rights reserved.**/

import styled from "styled-components"
import { homeGray } from "components/shell/presentation/AppStyles"
import { dgIconNames } from "hooks/dgIcons"
import { ButtonRoot, CommandButton, IconAlignment } from "components/cards/CommandButton";

const NavigationButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: center;
    margin: 20px;

    span {
        white-space: pre;
    }

    ${ButtonRoot} {
        gap: 10px;
    }
`;

export enum NavDirection {
    Right,
    Left
}

interface DocumentNavButtonProps {
    label: string;
    iconName: dgIconNames;
    iconAlignment: IconAlignment;
    onClick: () => void;
    disabled?: boolean;
}

export const DocumentNavButton = (props: DocumentNavButtonProps) => {
    return (
        <NavigationButtonContainer>
            <CommandButton
                command={{
                    label: props.label,
                    showLabel: true,
                    icon: {
                        name: props.iconName,
                        height: 15,
                        width: 8,
                        defaultColor: homeGray
                    },
                    canExecute: !props.disabled,
                    onClick: props.onClick,
                }}
                width={8}
                height={15}
                fontSize={18}
                iconAlignment={props.iconAlignment} />
        </NavigationButtonContainer>
    );
}

interface DocumentNavDisplayProps {
    iconName: dgIconNames;
    label: string;
}

export const prevDocumentNavProps: DocumentNavDisplayProps = {
    iconName: dgIconNames.DgPreviousArrow,
    label: 'Prev\nDoc'
}

export const nextDocumentNavProps: DocumentNavDisplayProps = {
    iconName: dgIconNames.DgNextArrow,
    label: 'Next\nDoc'
}

export function getNavigationTargetDocument(currentDocument: string, documents: string[], reverse: boolean = false, shouldLoop?: boolean) {
    const currentIndex = documents.indexOf(currentDocument);
    if (currentIndex === -1) {
        return undefined;
    }

    const increment = reverse ? -1 : 1;
    let targetIndex = currentIndex + increment;
    if (shouldLoop) {
        targetIndex = (targetIndex + documents.length) % documents.length;
    }

    return documents[targetIndex];
}